import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { isDev } from "solid-js/web"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const isEnvBrowser = () => {
  return typeof window !== "undefined" && !(window as any).invokeNative
}

export function isFiveMBrowser(): boolean {
  return typeof window !== "undefined" && typeof (window as any).GetParentResourceName === "function"
}

export const websocketUrl = () => {
  return `ws://localhost:${isDev ? 3001 : 3000}/api/ws`
}

export function formatTimeSince(sinceDate: Date): string | null {
  // Check if the input Date object is valid
  if (isNaN(sinceDate.getTime())) {
    console.error("Invalid Date object provided.")
    return null
  }

  const now = new Date()
  const differenceInMs = now.getTime() - sinceDate.getTime()

  const isPast = differenceInMs >= 0
  const absDifferenceInMs = Math.abs(differenceInMs)

  const seconds = Math.floor(absDifferenceInMs / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  const months = Math.floor(days / 30.44) // Average days in a month (365.25 / 12)
  const years = Math.floor(days / 365.25) // Average days in a year

  let value: number
  let unit: string

  if (years > 0) {
    value = years
    unit = "year"
  } else if (months > 0) {
    value = months
    unit = "month"
  } else if (days > 0) {
    value = days
    unit = "day"
  } else if (hours > 0) {
    value = hours
    unit = "hour"
  } else if (minutes > 0) {
    value = minutes
    unit = "minute"
  } else if (seconds > 0) {
    value = seconds
    unit = "second"
  } else {
    return "just now"
  }

  const plural = value !== 1 ? "s" : ""
  const suffix = isPast ? "ago" : "from now"

  return `${value} ${unit}${plural} ${suffix}`
}
